import { get, post, put, del, patch } from '../../../../Utility/Http';
import { paymentDetailsApiGet, bookingListGet, reviewPostGet, reviewImagePostGet, viewBookingDetailsGet, bookingsIndividualDetailsGet, bookingCancellationApi, uploadScreenshotPost, folioHistoryListGet, consumedItemsGet, folioDetailsGet, getPersonDetailsGet } from '../Model/BookingModel';


export const paymentDetailsApi = (id) => {
    return get(`${process.env.EXTENDED_URL}onpay/online_payment_detail/${id}`, null).then((response) => {
        return paymentDetailsApiGet(response)
    });
};

export const bookingList = (data) => {
    return get(`${process.env.EXTENDED_URL}customer/bookings`, data).then((response) => {
        return bookingListGet(response)
    });
};
export const folioHistoryList = (data) => {
    return get(`${process.env.EXTENDED_URL}v4/folio`, data).then((response) => {
        return folioHistoryListGet(response)
    });
};

export const reviewPost = (data) => {
    return post(`${process.env.EXTENDED_URL}customer/rating`, data).then((response) => {
        return reviewPostGet(response)
    });
};

export const reviewImagePost = (data) => {
    return post(`${process.env.EXTENDED_URL}customer/rating/upload_image`, data).then((response) => {
        return reviewImagePostGet(response)
    });
};

export const viewBookingDetailsApi = async (id, data = null) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/bookings/individual/${id}/invoice`, data);
    return viewBookingDetailsGet(response);
};

export const bookingsIndividualDetails = (id, data) => {
    return get(`${process.env.EXTENDED_URL}customer/bookings/individual/${id}/cancelled`, data).then((response) => {
        return bookingsIndividualDetailsGet(response)
    });
};

export const bookingCancelled = (id, data) => {
    return patch(`${process.env.EXTENDED_URL}customer/bookings/individual_update/${id}`, data).then((response) => {
        return bookingCancellationApi(response)
    });
};

export const uploadScreenshot = (data) => {
    return post(`${process.env.EXTENDED_URL}payment/upload_screensort`, data).then((response) => {
        return uploadScreenshotPost(response)
    });
};

export const getConsumedItems = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}${'v4'}/item_consumption_logs/guest_inventory_report`, data);
    return consumedItemsGet(response);
};

export const folioDetailsApi = async (id, data) => {
    const response = await get(`${process.env.EXTENDED_URL}${'v4'}/folio/details/${id}`, data);
    return folioDetailsGet(response);
};
export const getPersonDetails = async (id, data) => {
    let response = ''

    if (data && data != null && data.template_type != null) {
        const query = new URLSearchParams(data).toString();
        response = await get(`${process.env.EXTENDED_URL}${'v4'}/customerDetails/booking_customer/${id}?${query}`);
    } else {
        response = await get(`${process.env.EXTENDED_URL}${'v4'}/customerDetails/booking_customer/${id}`);
    }
    return getPersonDetailsGet(response);
};